module.exports = __webpack_public_path__ + "static/media/robo-theme.e695403e.wav";